import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    LastName: {
      validations: []
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    EventExtra1: {
      validations: []
    },
    EventExtra2: {
      validations: []
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    },
    Theme: {
      validations: []
    },
    Notes: {
      validations: []
    },
    EventExtra3: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: '1800 Drayton Event Center & Catering',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name',
            mapping: 'FirstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email',
            mapping: 'Email'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What type of event are you planning?',
            options: [
              { label: 'Wedding' , value: 'Wedding'},
              { label: 'Rehearsal Dinner', value: 'Rehearsal Dinner'},
              { label: 'Corporate Reception', value: 'Corporate Reception'},
              { label: 'Seminar or Training', value: 'Seminar or Training' },
              { label: 'Fund Raiser', value: 'Fund Raiser' },
              { label: 'Other *Please note in comments section below', value: 'Other *Please note in comments section below'},
            ],
            mapping: 'Theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'What is the date of your event?',
            mapping: 'EventDate'
      },
      {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Is this date firm?',
            options: [
              { label: 'Yes', value: 'Yes' },
              { label: 'No', value: 'No' },
            ],
            mapping: 'EventExtra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What time of the day would you like?',
            options: [
              { label: 'Early Morning (Breakfast/Brunch)', value: 'Early Morning (Breakfast/Brunch)' },
              { label: 'Mid Day', value: 'Mid Day' },
              { label: 'Evening', value: 'Evening' },
              { label: 'All Day', value: 'All Day' },
              { label: 'Multiple Day', value: 'Multiple Day' },
            ],
            mapping: 'EventExtra2'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'How many guests are you expecting?',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Tell us about your event:',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'How did you hear about us?',
            options: [
              { label: 'I was a guest at an event held on-site', value: 'I was a guest at an event held on-site' },
              { label: 'I am a resident at Drayton Mills', value: 'I am a resident at Drayton Mills' },
              { label: 'Google', value: 'Google' },
              { label: 'Friend', value: 'Friend' },
              { label: 'Radio', value: 'Radio' },
              { label: 'Billboard', value: 'Billboard' },
              { label: 'Wedding Planner', value: 'Wedding Planner' },
              { label: 'Other Wedding Vendor', value: 'Other Wedding Vendor' },
              { label: 'Other', value: 'Other'},
            ],
            mapping: 'EventExtra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: '1800 Drayton Catering Contact Form',
    formId: '589',
    clientKey: '437DF654-C3FF-4A8D-8582-CF15A91A66D9',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/1800drayton/form_structure.js